// extracted by mini-css-extract-plugin
export default {"brandPromo":"yW-z","carousel":"zW-z"};